import React, {useState, forwardRef, useImperativeHandle, useRef} from "react";
import * as bootstrap from "bootstrap";

const UniversalAddressModal = forwardRef(({countries}, ref) => {
    const modalRef = useRef(null);
    const bsModalRef = useRef(null);
    const [form, setForm] = useState({
        company: "",
        address_1: "",
        city: "",
        postcode: "",
        country: "SI",
        type: "billing",
        companyID: null,
        onSaved: null
    });

    useImperativeHandle(ref, () => ({
        openModal: ({type, companyID, onSaved, defaultValues}) => {
            setForm(prev => ({
                ...prev,
                type,
                companyID,
                onSaved,
                ...defaultValues
            }));

            if (!bsModalRef.current) {
                bsModalRef.current = new bootstrap.Modal(modalRef.current);
            }
            bsModalRef.current.show();
        }
    }));

    const handleChange = e => {
        const {name, value} = e.target;
        setForm(prev => ({...prev, [name]: value}));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.address_1 || !form.city  || !form.postcode) {
            alert("Izpolni vsa obvezna polja.");
            return;
        }

        if(form.type === "billing" && !form.ddv ) {
            alert("Izpolni vsa obvezna polja.");
            return;
        }

        const formData = new FormData();
        formData.append("action", "save_ekoda_multicompany_address");
        formData.append("nonce", window.billing.nonce);

        Object.entries(form).forEach(([k, v]) => {
            if (!["onSaved"].includes(k)) formData.append(k, v);
        });

        try {
            const res = await fetch(window.billing.ajax_url, {
                method: "POST",
                credentials: "same-origin",
                body: formData
            });
            const data = await res.json();

            if (!data.success) {
                alert(data.data?.message || "Napaka pri shranjevanju.");
                return;
            }

            form.onSaved?.(data.data.address);
            bsModalRef.current.hide();
        } catch (err) {
            console.error(err);
            alert("Napaka pri shranjevanju.");
        }
    };

    return (
        <div className="modal fade" id="universalAddressModal" tabIndex="-1" ref={modalRef}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h3>{form.type === "billing" ? "Dodaj plačnika" : "Dodaj dostavni naslov"}</h3>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"/>
                    </div>

                    <div className="modal-body">


                        {/* Stroškovno mesto */}
                        {form.type === "billing" && <div className="mb-3">
                            <label className="form-label">Stroškovno mesto</label>
                            <input
                                className="form-control"
                                name="sm_name"
                                value={form.sm_name}
                                onChange={handleChange}
                                placeholder="Naziv stroškovnega mesta"
                            />
                        </div> }

                        {/* Company */}
                        <div className="mb-3">
                            <label className="form-label">Naziv podjetja</label>
                            <input
                                className="form-control"
                                name="company"
                                value={form.company}
                                onChange={handleChange}
                                placeholder="Naziv podjetja"
                            />
                        </div>

                        {/* Davčna številka  */}
                        {form.type === "billing" && <div className="mb-3">
                            <label className="form-label">Davčna številka* </label>
                            <input
                                className="form-control"
                                name="ddv"
                                value={form.ddv}
                                onChange={handleChange}
                                placeholder="Davčna številka "
                            />
                        </div> }



                        {/* Address */}
                        <div className="mb-3">
                            <label className="form-label">Ulica</label>
                            <input
                                className="form-control"
                                name="address_1"
                                value={form.address_1}
                                onChange={handleChange}
                                placeholder="Ulica in hišna številka"
                            />
                        </div>

                        {/* Postcode & City */}
                        <div className="row g-0">
                            <div className="col-md-6 mb-3 mr-1">
                                <label className="form-label">Poštna št.</label>
                                <input
                                    className="form-control"
                                    name="postcode"
                                    value={form.postcode}
                                    onChange={handleChange}
                                    placeholder="Poštna številka"
                                />
                            </div>
                            <div className="col-md-6 mb-3 ml-1">
                                <label className="form-label">Mesto</label>
                                <input
                                    className="form-control"
                                    name="city"
                                    value={form.city}
                                    onChange={handleChange}
                                    placeholder="Mesto"
                                />
                            </div>
                        </div>

                        {/* Country */}
                        <div className="mb-3">
                            <label className="form-label">Država</label>
                            <select
                                className="form-select country_to_state country_select"
                                name="country"
                                value={form.country}
                                onChange={handleChange}
                                autoComplete="country"
                            >
                                <option value="">Izberi državo / regijo…</option>
                                {Object.entries(countries).map(([code, name]) => (
                                    <option key={code} value={code}>{name}</option>
                                ))}
                            </select>
                        </div>

                        {/* Telefon   */}
                        {form.type === "billing" && <div className="mb-3">
                            <label className="form-label">Telefon </label>
                            <input
                                className="form-control"
                                name="phone"
                                value={form.phone}
                                onChange={handleChange}
                                placeholder="Telefon "
                            />
                        </div> }


                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Prekliči</button>
                        <button type="button" className="btn btn-primary" onClick={handleSubmit}>Shrani</button>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default UniversalAddressModal;
